import { Component, Output, EventEmitter, HostListener, Input } from '@angular/core';

@Component({
    selector: 'app-bom-view-dropdown',
    templateUrl: './bom-view-dropdown.component.html',
    styleUrls: ['./bom-view-dropdown.component.scss'],
    standalone: false
})
export class BomViewDropdownComponent {

  isOpenedViewSelect = false;

  @Input() displayPrice: boolean;

  @Output() togglePriceView = new EventEmitter<string>();

  @HostListener('document:click')
  onClick() {
    if (this.isOpenedViewSelect === true) {
      this.isOpenedViewSelect = false;
    }
  }

  togglePrice() {
    this.togglePriceView.emit();
    this.changeArrowDirection();
  }

  changeArrowDirection() {
    this.isOpenedViewSelect = !this.isOpenedViewSelect;
  }

}
